import { davimaDocValidations } from "./davima";
import { telparkDocValidations } from "./telpark";

export const docValidations = {
  ...telparkDocValidations,
  ...davimaDocValidations,
  doc_validation_docdate_greater_accountingdate: `La fecha del documento no puede ser mayor que la fecha de contabilización`,
};
